import React from 'react';
import { Anchor } from 'antd';
const { Link } = Anchor;
export default function TabAnchor(props) {
    const { navs } = props;
    return (<Anchor className="toc-affix" showInkInFixed={true} offsetTop={64} offsetBottom={100}>
      {navs.map(({ title, code }) => (<Link href={`#${code}`} key={code} title={title}/>))}
    </Anchor>);
}
